import { Box, Stack, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import { replacePathParams } from 'utils/routes.utils';

import { Routes } from 'constants/routes.constants';
import { EnhancedTicketsEventCard } from 'types/tickets.types';

import LinkUnstyled from 'components/@common/LinkUnstyled';
import EventListItem from 'components/@events/EventListItem';

interface Props {
  events: Array<EnhancedTicketsEventCard>;
}

const PastEventItem = ({ event }: { event: EnhancedTicketsEventCard }) => {
  return (
    <EventListItem
      component={LinkUnstyled}
      href={replacePathParams(Routes.AccountTicketsDetail, {
        slug: event.slug,
      })}
    >
      <EventListItem.Cover cover={event.cover} style={{ opacity: 0.7 }} />
      <EventListItem.Content sx={{ flexGrow: 1 }}>
        <EventListItem.Title color="grey.600">
          {event.title}
        </EventListItem.Title>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Box
            sx={{
              flexGrow: '1',
            }}
          >
            <EventListItem.Date
              startDatetime={event.startDatetime}
              endDatetime={event.endDatetime}
              timezone={event.timezone}
              color="grey.600"
            />
            <EventListItem.City city={event.venue.city.name} color="grey.600" />
          </Box>
          <EventListItem.TicketsIndicator
            quantity={event.ticketCount}
            color="grey.600"
          />
        </Box>
      </EventListItem.Content>
    </EventListItem>
  );
};

const PastEvents = ({ events }: Props) => {
  if (!events.length) return null;

  return (
    <Box>
      <Typography
        variant="h6"
        sx={{
          py: 2,
          color: 'text.secondary',
        }}
      >
        <FormattedMessage id="account.tickets.past.title" />
      </Typography>
      <Stack
        sx={{
          gap: 2,
        }}
      >
        {events.map((event) => (
          <PastEventItem key={event.id} event={event} />
        ))}
      </Stack>
    </Box>
  );
};

export default PastEvents;
